import moment from "moment";

/** Backend summary signature clocks are UTC in this format. PDF keeps that UTC clock. */
export const REPORT_SUMMARY_SIGNATURE_UTC_FORMAT = "DD/MM/YYYY HH:mm:ss";

/** On-screen report summary signature clock, in the laptop's local timezone. */
export const REPORT_SUMMARY_SIGNATURE_FORMAT = "DD/MM/YYYY h:mm:ss A";

/**
 * Show a report-summary signature time in the laptop's local timezone.
 * Accepts the UTC display clock from the summary API, or an ISO timestamp.
 */
export function formatReportSummarySignatureLocal(value?: string | null): string {
	if (value == null || value.trim() === "") {
		return "";
	}

	const utcClock = moment.utc(value, REPORT_SUMMARY_SIGNATURE_UTC_FORMAT, true);
	if (utcClock.isValid()) {
		return utcClock.local().format(REPORT_SUMMARY_SIGNATURE_FORMAT);
	}

	const iso = moment.utc(value, moment.ISO_8601, true);
	if (iso.isValid()) {
		return iso.local().format(REPORT_SUMMARY_SIGNATURE_FORMAT);
	}

	return value;
}
